export default __webpack_public_path__ + "static/media/024-Chichen Itza.24bdf171.svg";